import { useRef } from 'react';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import { Box, Text, List, ListIcon, ListItem, Image, Link } from '@chakra-ui/react';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import HoverTilesSection from '../../sections/HoverTilesSection/HoverTilesSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import { CheckIcon } from '@chakra-ui/icons';

interface Props {}
export default function MultichannelPage(props: Props) {
    const marketplaces = [
        {
            title: 'Allegro',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600215&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/integracja-sklepu-internetowego-z-serwisem-aukcyjnym-allegro/',
        },
        {
            title: 'Amazon',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600216&ext=.svg',
            href: 'https://www.idosell.com/pl/amazon/',
        },
        {
            title: 'Ebay',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600217&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/integracja-sklepu-internetowego-z-serwisem-aukcyjnym-ebay/',
        },
        {
            title: 'Empik',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600218&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/sprzedawaj-towary-poprzez-zintegrowany-empik-marketplace/',
        },
        {
            title: 'Ceneo',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600219&ext=.svg',
            href: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/porownywarki-cen-serwisy-opinii-katalogi-produktow-generuj-oferty-bez-skladania-zamowien-w-wielu-miejscach-jednoczesnie/eksport-oferty-do-ceneo-w-idosell-to-proste/',
        },
        {
            title: 'Emag',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600220&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/integracja-idosell-z-emag-marketplace/',
        },
        {
            title: 'Erli',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600221&ext=.svg',
            href: '#',
        },
        {
            title: 'Nethansa',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600222&ext=.svg',
            href: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/nethansa/',
        },
        {
            title: 'Morele',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600223&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/darmowa-integracja-z-morele-net-marketplace/',
        },
        {
            title: 'CDISCOUNT',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600224&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/cdiscount/',
        },
        {
            title: 'Spartoo',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600225&ext=.svg',
            href: 'https://www.idosell.com/pl/marketplaces/spartoo/',
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={'Sprzedaż wielokanałowa i Multistore w\u00A0IdoSell'}
                subTitle="Dotrzyj do klientów tam, gdzie kupują najchętniej! Marketplace’y, sklepy stacjonarne, porównywarki cenowe i cross-border – sprzedaż wielokanałowa to większy zasięg i więcej możliwości."
                image={{
                    url: 'https://www.idosell.com/panel/file-gate.php?id=600195&ext=.webp',
                    alt: 'Zdjęcie wyróżniające w hero - strona multichannel',
                }}
            />

            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                >
                    <Box display={'flex'} flexDir={{ base: 'column', lg: 'row' }} gap={'30px'}>
                        <Image
                            src="https://www.idosell.com/panel/file-gate.php?id=600194&ext=.webp"
                            alt="Zdjęcie sekcji z tickami"
                        />
                        <Box
                            p={'30px'}
                            display={'flex'}
                            flexDir={'column'}
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                        >
                            <Text
                                fontSize={'34px'}
                                lineHeight={'1.5'}
                                fontWeight={'600'}
                                color={'#1AAC7A'}
                                mb="30px"
                            >
                                Wiele sklepów i wygodna obsługa zamówień z jednego panelu IdoSell
                            </Text>
                            <List
                                spacing={'30px'}
                                fontSize={'18px'}
                                lineHeight={'27px'}
                                color={'#171717'}
                            >
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={CheckIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            color={''}
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Łatwa obsługa zamówień z różnych kanałów
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Zamówienia z różnych sklepów znajdują się w jednej,
                                            wspólnej kolejce. Widzisz od razu wszystkie zdarzenia
                                            (nowe zamówienia, rejestracje klientów, reklamacje)
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={CheckIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Zarządzanie magazynami dla wszystkich sklepów
                                            jednocześnie
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Dzięki wbudowanemu systemowi WMS możesz wygodnie
                                            zarządzać magazynami dla wszystkich sklepów jednocześnie
                                        </Text>
                                    </Box>
                                </ListItem>
                            </List>
                            <Link
                                href="https://pomoc.idosell.com/administracja/dodawanie-i-usuwanie-sklepow-wiele-sklepow-w-jednym-panelu"
                                background={'#171717'}
                                color={'white'}
                                padding={'12px 30px'}
                                fontSize={'16px'}
                                fontWeight={'600'}
                                display={'flex'}
                                alignItems={'center'}
                                gap={'10px'}
                                _hover={{
                                    underline: 'none',
                                    background: 'rgba(11, 113, 83, 0.5)',
                                }}
                            >
                                Włacz Multistore
                                <svg
                                    width="9"
                                    height="14"
                                    viewBox="0 0 9 14"
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                </svg>
                            </Link>
                        </Box>
                    </Box>
                    <TilesSection
                        title={'Multistore - wiele sklepów w jednym panelu'}
                        subtitle={
                            'Zarządzaj wieloma sklepami z jednego panelu IdoSell. Dzięki wbudowanej opcji Multistore możesz prosto i wygodnie zarządzać wieloma sklepami, które obsługują różne waluty i języki.'
                        }
                        tiles={[
                            {
                                title: 'Spójny proces realizacji zamówień',
                                content:
                                    'Jeden proces dla realizacji i zarządzania zamówieniami uprości ich obsługę oraz skróci czas realizacji.',
                            },
                            {
                                title: 'Sprzedaż w wielu miejscach',
                                content:
                                    'Multichannel, czyli sprzedaż wielokanałowa to dziś konieczność w e-commerce. W Multistore od IdoSell możesz mieć wiele punktów odbiorów i zarządzać nimi z jednego miejsca.',
                            },
                            {
                                title: 'Kontrola sprzedaży ponad stan',
                                content:
                                    'Sprzedaż w jednym sklepie oznacza natychmiastową aktualizację informacji w pozostałych sklepach. Dzięki temu kontrolujesz stany magazynowe i nie sprzedasz produktu, którego nie posiadasz.',
                            },
                            {
                                title: 'Wyświetlanie towarów w różnych sklepach',
                                content:
                                    'Wygodnie i w prosty sposób możesz wskazać, w którym sklepie lub sklepach wyświetla się dany produkt (możesz to robić także zbiorowo za pomocą Grupowej Edycji Produktów)',
                            },
                            {
                                title: 'Łatwe zarządzanie cenami',
                                content:
                                    'Decydujesz w których kanałach sprzedajesz towar w jakiej cenie. Masz możliwość ustawiania różnych cen dla różnych sklepów',
                            },
                            {
                                title: 'Wspólna baza produktów',
                                content:
                                    'Baza produktów jest wspólna, dzięki czemu łatwo dostosujesz ofertę. Każdy twój produkt w kilka sekund może pojawić w ofercie dowolnego innego sklepu w panelu.',
                            },
                        ]}
                    />
                    <Box pt={5}>
                        <SectionWithPlusTick
                            alignItems={'center'}
                            display={'flex'}
                            flexDirection={'column'}
                            background={'#1AAC7A'}
                            title="Sprzedaż stacjonarna i online w jednym miejscu"
                            subtitle="Połącz swój sklep internetowy i stacjonarny w jednym nowoczesnym systemie POS. Zarządzaj zamówieniami z różnych kanałów i zwiększ sprzedaż bez wysiłku."
                            ctaButton={{
                                label: 'Wypróbuj POS',
                                href: '#',
                            }}
                            image={{
                                url: 'https://www.idosell.com/panel/file-gate.php?id=600196&ext=.webp',

                                alt: 'Zdjęcie Pani z założonymi rękami',
                            }}
                            imageResponsive={{
                                base: {
                                    alt: 'Zdjęcie Pani z założonymi rękami',
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=600467&ext=.jpeg',
                                },
                                md: {
                                    alt: 'Zdjęcie Pani z założonymi rękami',
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=600196&ext=.webp',
                                },
                            }}
                            tickItem={[
                                {
                                    title: 'Pełna integracja i spójność cen w sprzedaży online i offline',
                                },
                                {
                                    title: 'Zaawansowane narzędzia do obsługi klienta i synchronizacja magazynów',
                                },
                                {
                                    title: 'Spójne promocje, oferty specjalne i towary gratisowe',
                                },
                            ]}
                        />
                    </Box>
                    <HoverTilesSection
                        title="Sprzedawaj tam, gdzie są Twoi klienci"
                        subtitle="Dotrzyj do nowych klientów dzięki integracji z marketplace’ami i porównywarkami
                    cenowymi zarówno w Polsce, jak i zagranicą"
                        tickList={[
                            {
                                title: 'Automatyczna aktualizacja cen i stanów magazynowych',
                            },
                            {
                                title: 'Możliwość dostosowania oferty pod każdy kanał',
                            },
                            {
                                title: 'Integracja z systemami logistycznymi i płatnościami',
                            },
                        ]}
                        buttons={[
                            {
                                title: 'Sprzedawaj na marketplace’ach',
                                href: 'https://www.idosell.com/pl/marketplaces/',
                                variant: 'default',
                            },
                        ]}
                        tiles={marketplaces}
                    />

                    <MigrationSection
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=600197&ext=.jpeg',
                        }}
                        boxSide="right"
                        title={'Sprzedawaj bez granic z\u00A0IdoSell'}
                        subtitle="Wejdź na nowe rynki dzięki nowoczesnym rozwiązaniom od IdoSell. Zyskaj klientów i otwórz sklep zagraniczny z dowolną walutą i lokalnymi metodami płatności"
                        ctaButton={{
                            title: 'Otwórz sklep zagraniczny',
                            href: 'https://www.idosell.com/pl/sprzedaz-miedzynarodowa/',
                            variant: 'default',
                        }}
                    >
                        <>
                            <List
                                spacing={'20px'}
                                fontSize={'18px'}
                                lineHeight={'27px'}
                                color={'#171717'}
                                marginBottom={'35px'}
                            >
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Text
                                        color={''}
                                        fontSize={'16px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'400'}
                                        mb="5px"
                                    >
                                        Tłumaczenie sklepu na ponad 30 języków
                                    </Text>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Text
                                        color={''}
                                        fontSize={'16px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'400'}
                                        mb="5px"
                                    >
                                        Lokalne metody płatności i wysyłki Integracje z
                                        marketplace’ami i porównywarkami
                                    </Text>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Text
                                        color={''}
                                        fontSize={'16px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'400'}
                                        mb="5px"
                                    >
                                        Sklep internetowy, który spełnia wymogi prawne UE
                                    </Text>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Text
                                        color={''}
                                        fontSize={'16px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'400'}
                                        mb="5px"
                                    >
                                        SEO – ustaw osobne zestawy słów kluczowych dla każdego
                                        języka
                                    </Text>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Text
                                        color={''}
                                        fontSize={'16px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'400'}
                                        mb="5px"
                                    >
                                        Integracje z marketplace’ami i porównywarkami
                                    </Text>
                                </ListItem>
                            </List>
                        </>
                    </MigrationSection>
                    <ContactSection />
                </Box>
            </div>
        </ThemeProvider>
    );
}
